// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__1HIjS","content":"style_content__3PqFd"};